<template>
    <div class="panel panel-flat">
        <div class="panel-heading">
            <h5>{{transEdit('revenue')}}</h5>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-md-6">
                    <admin-dash-revenue-graph :revenue="revenue">
                    </admin-dash-revenue-graph>
                </div>

                <div class="col-md-6">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>{{transEdit('date')}}</th>
                            <th class="text-right">{{transEdit('revenue')}} (SEK)</th>
                            <th> </th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="day in revenue">
                            <td>{{day.date}}</td>
                            <td class="text-right">{{numberWithCommas(day.revenue)}} kr</td>
                            <td> </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['part'],
        data: function () {
            return {
                revenue: [],
            };
        },
        name: "admin-dash-revenue",
        mounted () {
            let self = this;
            axios.get(this.part.route_refresh)
                .then(function (response) {
                    self.revenue = response.data.revenue;
                })
                .catch(function (error) {
                })
        },
        methods: {
            numberWithCommas(x) {
                return number_format_no_zero_decimals(x, 2, ",", " ");
                //x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            },
        }
    }
</script>

<style scoped>

</style>
